import { LayoutGrid } from '@jouzen/ecom-components/v3/LayoutGrid';
import { useDynamicConfig } from '@statsig/react-bindings';

import type { Profile } from '../MABRow/MABRow';
import MABRow from '../MABRow/MABRow';

const MABGrid = () => {
  const { value } = useDynamicConfig('medical_advisory_board_profiles');
  const profiles = value['profiles'] as Profile[];

  return (
    <section
      className="bg-sandstone-200 text-sandstone-500 md:px-5"
      data-cy="MAB-grid"
    >
      {profiles.map(
        (
          { media, name, titleKey, bioKey, certifiedAdvisorKey }: Profile,
          index: number,
        ) => {
          const isEven = index % 2 === 0;
          return (
            <LayoutGrid
              className="w-full gap-y-16 pb-32 md:content-between md:items-start md:gap-y-32"
              key={bioKey}
              data-cy={name}
            >
              <MABRow
                isEven={isEven}
                index={index}
                media={media}
                name={name}
                titleKey={titleKey}
                bioKey={bioKey}
                certifiedAdvisorKey={certifiedAdvisorKey}
              />
            </LayoutGrid>
          );
        },
      )}
    </section>
  );
};

export default MABGrid;
